import { Redirect } from "react-router-dom"

function RedirectSchedule() {
	return <Redirect to='/admin/schedule/worship' />
}

export default RedirectSchedule
